module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays-img-3.988760dc.jpeg";